/**
 * DescriptionAddonTick component.
 */
import Addon from '@shared/classes/addon';
import Content from '@shared/types/enums/content';
import Container from '@components/atoms/container/descriptionAddonTickContainer';
import Tick from '@components/atoms/icons/tick';

export default function DescriptionAddonTick({ asset }: { asset: Addon }) {
  let hasAddon = false;
  if (asset?.type === Content.ADDON) {
    hasAddon = asset.checkAddon();
  }
  return hasAddon ? (
    <Container>
      <Tick />
    </Container>
  ) : null;
}
